import { render } from "./UserCard.vue?vue&type=template&id=87f9ed90&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"

import "./UserCard.vue?vue&type=style&index=0&id=87f9ed90&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f9ed90"]])

export default __exports__